import { useLayoutEffect, useSyncExternalStore } from "react";
import {
  ERASER_RADIUS_PRESETS,
  getEraserSettings,
  setEraserSettings,
  subscribeEraserSettings,
} from "../../editor/eraserSession";

/** Диаметр кружка в кнопке — тот же порядок, что у настоящего круга на доске. */
function dotSize(radius: number): number {
  return Math.min(22, Math.max(6, Math.round(radius * 0.8)));
}

export function BoardEraserOptions() {
  const eraser = useSyncExternalStore(
    subscribeEraserSettings,
    getEraserSettings,
    getEraserSettings
  );

  useLayoutEffect(() => {
    window.dispatchEvent(new Event("wb:tool-options-layout"));
  }, []);

  return (
    <div
      className="wb-pen-options wb-eraser-options"
      role="group"
      aria-label="Параметры ластика"
      onPointerDown={(ev) => ev.stopPropagation()}
    >
      <div className="wb-pen-options__widths" role="group" aria-label="Размер ластика">
        {ERASER_RADIUS_PRESETS.map((p) => (
          <button
            key={p.radius}
            type="button"
            className={`wb-pen-options__width${eraser.radius === p.radius ? " is-active" : ""}`}
            title={p.title}
            aria-label={p.title}
            aria-pressed={eraser.radius === p.radius}
            onClick={() => setEraserSettings({ radius: p.radius })}
          >
            <span
              className="wb-eraser-options__size-dot"
              style={{ width: dotSize(p.radius), height: dotSize(p.radius) }}
            />
          </button>
        ))}
      </div>
    </div>
  );
}
